import { IMapComponent } from "@components/map/map.models";
import { IMapDrawLayer, IMapSettings } from "@components/map/map.settings";
import { ITplDestineringRuttQueryResult } from "../../../../models/queries";
import { TplTransportavstandKartaLayers } from "./tpl-transportavstand-karta.layers";

export class TplTransportavstandKartaViapunkter extends TplTransportavstandKartaLayers {

    load(data: ITplDestineringRuttQueryResult, mapsettings: IMapSettings, map: IMapComponent) {
        const geometries = [];
        const aktivBk = data.arbetsorderTransportavtand.find(x => x.active);
        aktivBk?.viaPunkter?.forEach((viapunkt, index) => {
            geometries.push({
                id: `viapunkter_${index}`,
                label: "Viapunkt",
                easting: viapunkt.easting,
                northing: viapunkt.northing,
                iconid: "viapunktIcon",
                visible: true
            });
        });

        mapsettings.drawLayers.find(x => x.id === "viapunkter").geometries = geometries;
        map.refreshGeometries("viapunkter");
    }

    getLayer() {
        return {
            id: "viapunkter",
            title: "Viapunkter",
            showGeometriesMenu: false,
            visible: true,
            readonly: true,
            autoZoom: true,
            zoomable: true,
            geometries: [],
            selectable: false,
            hideInLayerList: true,
            onClick: (mouseevent: any, geometry: any) => this.parent.selectPoint(mouseevent, geometry, "viapunkter"),
            drawOptions: [
                {
                    title: ``,
                    type: "point",
                    callback: (g) => {
                    // Kräver callback
                    },
                    onBeforeDraw: () => true
                }
            ]
        } as IMapDrawLayer;
    }
}
